import Tasks from 'APP/Tasks';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { Schedule } from 'STORE/Groups/Schedule';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { MessageError } from 'STORE/Messages/Message/ChatMessage/ChatMessages.types';

async function sendMessages(
  groupId: string,
  messages: ChatMessage[],
  callback: (groupId: string, msg: ChatMessage, result: boolean) => void
): Promise<void> {
  messages.forEach(async (msg) => {
    try {
      await messageModel.sendScheduledMessageNow(groupId, msg.id);

      callback(groupId, msg, true);
    } catch {
      callback(groupId, msg, false);
    }
  });
}

const sendMessageHandler = (groupId: string, msg: ChatMessage, result: boolean): void => {
  if (result) {
    Tasks.messaging.clearScheduledMessages(groupId, [msg.id]);
  } else {
    msg.setError(MessageError.Send);
  }
};

export function sendNowScheduledMessages(groupId: string, messages: ChatMessage[]): void {
  const scheduledGroup = Entities.GroupsStore.getGroupById(groupId) as Schedule;
  if (!scheduledGroup) {
    return;
  }

  const group = Entities.GroupsStore.getGroupById(scheduledGroup.groupId!);
  if (!group) {
    return;
  }

  sendMessages(group.id, messages, sendMessageHandler);
}
